module.exports = __webpack_public_path__ + "img/hospital-laureano.eb0cdd2a.png";